import "./LockModal.css";
import classnames from "classnames";

import { useAppSelector, useAppDispatch, lockModalHidden } from "./store";

function LockModal() {
  const dispatch = useAppDispatch();
  const lockModalState = useAppSelector((state) => {
    return state.display.lockModal;
  });

  const players = useAppSelector((state) => {
    return state.players;
  });

  const lockingPlayer = players.find(
    (player) => player.id === lockModalState.playerID,
  );

  const handleOkClick = () => {
    dispatch(lockModalHidden(undefined));
  };

  const modalClasses = classnames("lockContainer", {
    hidden: !lockModalState.enabled,
  });

  return (
    <div className={modalClasses}>
      <div className="lockModal">
        <div>
          {lockingPlayer?.name} has locked {lockModalState.color}
        </div>
        <div>
          <button className="primaryButton" onClick={handleOkClick}>
            Ok
          </button>
        </div>
      </div>
      <div className="overlay"></div>
    </div>
  );
}

export default LockModal;
